import React, { useState } from 'react';
import { StlViewer } from 'react-stl-viewer';
import '../styles/StlViewer.css';

const StlModelViewer = ({ url, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const style = {
    width: '100%',
    height: '400px',
  };

  return (
    <div className="stl-viewer-container">
      <button 
        className="stl-view-button" 
        onClick={() => setIsOpen(true)}
      >
        View {title}
      </button>
      
      {isOpen && (
        <div className="stl-modal">
          <div className="stl-modal-content">
            <button 
              className="stl-close-button"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
            <h4>{title}</h4>
            <StlViewer
              style={style}
              url={url}
              modelColor="#B92C2C"
              backgroundColor="#2A2A2A"
              rotate={true}
              orbitControls={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StlModelViewer; 